export const staticdata = {
    // paystackkeytest: "pk_test_4bd35154ba3b7968932f25aea08901f3d39b787b",
    paystackkeytest: "pk_test_2b2f4dfe05cfe7084c2fa5f3692e55f7e1eb82dc",
    paystackkeylive: "pk_live_4dabbcc1a3c405e3e1cb3ad759f543aed424693c"
  };
  
